import Ajax from 'js/utils/ajax/ajax';

export const getInvoiceBatches = (page: number) =>
  Ajax.get(`/invoices/v2/invoicebatches?processedInvoiceBatchesPage=${page}`);
